import React, { useContext, useState } from 'react'
import { ConfigContext } from 'contexts/config-context'
import { OrderPartyButton } from './styled'
import Icon from 'components.v2/Icon/IconV2'
import get from 'lodash/get'
import empty from 'lodash/isEmpty'
import OrderPartyContainer from './OrderPartyContainer'
import notif from 'services/notification'
import { isWhiteLabel } from 'utils/whiteLabel'
import { isMultiVendor } from 'utils/multiVendor'

const CreateOrderParty = props => {
  const config = useContext(ConfigContext)

  const vendorId = get(props, 'match.params.id')

  const {
    isAuthenticated,
    orderParty,
    showLoginModal,
    createOrderParty,
    showInviteModal,
    history,
    showActiveOrderPartyModal,
    hide,
    detachParty,
    pullStatus,
  } = props

  const isOrderPartyEnabled =
    get(config, 'features.order_party.enabled', false) &&
    !(isWhiteLabel() || isMultiVendor())

  const selectedOrderParty = get(orderParty, `parties.${vendorId}`)

  const handleClick = async () => {
    try {
      if (!isAuthenticated) {
        showLoginModal()
        return
      }

      if (!empty(selectedOrderParty)) {
        showActiveOrderPartyModal({
          handleClose: handleCloseHasActiveOrderParty,
          handleViewGroup,
          handleDismiss,
          activeOrderParty: selectedOrderParty,
        })
        return
      }

      const {
        value: { data },
      } = await createOrderParty({
        vendorId,
        inviteMessage: '',
        customerIds: [],
      })

      pullStatus(data.partyCode)

      showInviteModal(data)
    } catch (error) {
      if (get(error, 'orderParty')) {
        showActiveOrderPartyModal({
          handleClose: handleCloseHasActiveOrderParty,
          handleViewGroup,
          handleDismiss,
          activeOrderParty: get(error, 'orderParty'),
        })
      } else {
        notif.error({
          title: 'Order Party Error',
          message: get(error, `data.message`),
        })
      }
    }
  }

  const shouldDisplayOrderPartyButton =
    isOrderPartyEnabled && empty(get(orderParty, `parties.${vendorId}`))

  const handleViewGroup = () => {
    history.push(`/order/${vendorId}/review`)
    hide()
  }

  const handleCloseHasActiveOrderParty = () => {
    hide()
  }

  const handleDismiss = () => {
    detachParty(vendorId)
    hide()
  }

  return shouldDisplayOrderPartyButton ? (
    <div>
      <OrderPartyButton onClick={handleClick}>
        <Icon src="CreateOrderParty.svg" />
        Group Order
      </OrderPartyButton>
    </div>
  ) : (
    isAuthenticated && (
      <OrderPartyButton onClick={handleViewGroup}>
        <Icon src="ViewGroupOrder.svg" />
        View Group Order
      </OrderPartyButton>
    )
  )
}

export default OrderPartyContainer(CreateOrderParty)
